export class SelectOption {
  public value?: any;
  public label: string;
}
